import { useEffect } from "react";

import * as billPaymentAction from "store/entities/billPayment/action";

import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { renderStatusColor } from "utils/statusColor";
import Filter from "components/__new/common/Filter";
import { ReactComponent as IconUser } from "assets/images/icons/project-icons/single-user.svg"
// import { ReactComponent as IconUsers } from "assets/images/icons/project-icons/triple-users.svg"
import { TableContent } from "components/__new/common/TableContent";
import { DateFormat, TimeFormat } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import ContentLoading from "components/__new/common/ContentLoading";
import { useState } from "react";
import TableEmptyData from "components/__new/common/TableEmptyData";
import pluralize from "utils/pluralize";
import useBillPayments from "hooks/useBillPayments";
import { Menu } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as EditIcon } from "assets/images/icons/edit-3.svg"
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/trash-2.svg"
import DialogBox from 'utils/dialogBox';
import DropdownNew from "utils/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { useTransformedBillers } from "hooks/useTransformedBillers";
import EditElectricityBeneficiary from "components/__new/beneficiaries/electricity/EditElectricityBeneficiary";

export const ElectricityBeneficiariesTable = ({toggleCreateBeneficiary, getAllBeneficiaries, loading, data}) => {
    const dispatch = useDispatch()
    
    const { providers, providersLoading } = useSelector((state) => state.entities.billPayment)
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [viewElectricityBeneficiary, setViewElectricityBeneficiary] = useState(false)
    const { ElectricityBillerIcon } = useBillPayments();
    
    const electricityData = useTransformedBillers('electricity', providers?.response);
    
    
    const openTransactionDetail = (transaction) => {
        setSelected(transaction);
        setDetailsOpen(true);
    }
    
            
    const toggleEditModal = (transaction) => {
        setViewElectricityBeneficiary((prev => ({...transaction})))
        setOpenEditModal(!openEditModal)
    };
    

    const toggleDeleteModal = async (transaction) => {
        const result = await DialogBox({
			title: "Delete This Beneficiary",
            content: <div className="text-lg color-[#4A5564]">Are you sure you want to perform this action?</div>,
            // content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{group.name}</span>? This action cannot be undone.</div>,
			buttonYes: "Yes",
            buttonYesClass: "btn-ep-red w-[170px]",
            buttonNoClass: "w-[170px] btn-transparent border border-ep-primary focus:ring-2 focus:ring-transparent ",
			buttonNo: "No",
		});
		if (result) {
            dispatch(billPaymentAction.deleteBeneficiary(transaction?._id)).then(() => getAllBeneficiaries())
        }
    }
        
    useEffect(() => {
        dispatch(billPaymentAction.getProviders());
        // eslint-disable-next-line
    }, []);
    
    
    const transformDisplay = (data) => {
        return data?.map(item => {
            const transformedDisplay = item.display
                .replace(/_/g, ' ')                  // Replace underscores with spaces
                .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
            return {
                ...item,
                display: transformedDisplay
            };
        });
    };
    
    const transformElectricityData = transformDisplay(electricityData)
    
    
    return (
        <>
            <EditElectricityBeneficiary 
                isOpen={openEditModal}
                setIsOpen={setOpenEditModal}
                toggleEditModal={toggleEditModal}
                getAllBeneficiaries={getAllBeneficiaries}
                viewElectricityBeneficiary={viewElectricityBeneficiary}
                providerData={providers?.response}
                providers={providers}
                providersLoading={providersLoading}
            />
            <div>
                <div className="mt-6 box">
                    
                    <div className="flex items-center justify-start w-max">
                        <div className="font-medium">Electricity Beneficiaries&nbsp;</div>
                        
                        <div className="label h-6 text-sm font-normal text-ep-primary-600 bg-[#ecf2f2]">
                            <ContentLoading
                                loading={loading}
                                data={<>{data?.data?.totalDocs ?? "-"} {pluralize(data?.data?.totalDocs, "beneficiary", "beneficiaries")}</>}
                            />
                        </div>
                    </div>
                    
                    <div className="mt-6 flex flex-wrap justify-between">
                        <div className="max-w-sm flex-grow sm:mr-6">
                            <SearchBox placeholder="Search" name="search" extraUrlParams="page=1" />
                        </div>
                            
                        <div className="flex flex-wrap space-x-3 sm:space-x-6">
                            <div>
                                <Filter filters={[
                                    {
                                        title: "Date range",
                                        name: "dateRange",
                                        dataType: "custom-timeframe",
                                        hasResetButton: true,
                                        options: [
                                            {
                                                display: "Today",
                                                payload: "today",
                                            },
                                            {
                                                display: "Last 7 days",
                                                payload: "7days",
                                            },
                                            {
                                                display: "30 days",
                                                payload: "30days",
                                            },
                                            {
                                                display: "1 Year",
                                                payload: "1year",
                                            },
                                        ],
                                    },
                                    {
                                        title: "Custom Date Range",
                                        dataType: "date-range",
                                        options: {
                                            from: {
                                                name: "startDate",
                                                placeholder: "Start Date",
                                            },
                                            to: {
                                                name: "endDate",
                                                placeholder: "End Date",
                                            },
                                        },
                                    },
                                    {
                                        title: "Biller",
                                        name: "biller",
                                        dataType: "select",
                                        options: transformElectricityData,
                                    },
                                    {
                                        title: "Transaction Status",
                                        name: "status",
                                        dataType: "select",
                                        options: [
                                            {
                                                display: "All",
                                                payload: "",
                                            },
                                            {
                                                display: "Successful",
                                                payload: "successful",
                                            },
                                            {
                                                display: "Pending",
                                                payload: "pending",
                                            },
                                            {
                                                display: "Failed",
                                                payload: "failed",
                                            },
                                        ],
                                    },
                                ]}/>
                            </div>
                            
                            <NewBeneficiaryButton
                                buttonText="Add New Beneficiary"
                                toggleCreateBeneficiary={toggleCreateBeneficiary}
                            />
                            
                        </div>
                    </div>
                </div>
                    
                <div className="bg-white">

                    <Table classTable="table-hover">
                        <Table.Head>
                            <th>Meter Number</th>
                            <th>Meter Type</th>
                            <th>Meter Name</th>
                            <th>Biller</th>
                            <th></th>
                        </Table.Head>
                        <Table.Body>

                            <TableContent
                                loading={loading}
                                loadingText="Fetching Beneficiaries"
                                data={data?.data?.docs}
                                colspan={6}
                                emptyUI={
                                    <TableEmptyData 
                                        actionButtonClicked={toggleCreateBeneficiary}
                                        actionButtonText="Click here to add new beneficiary"
                                    />
                                }
                            />

                            {loading === false && data?.data?.docs?.map((transaction) => {
                                const name = transaction?.product;
                                
                                return (
                                    <tr key={transaction._id} onClick={() => openTransactionDetail(transaction)}>
                                        <td>
                                            {transaction?.meterNumber}
                                        </td>
                                        <td>
                                            {transaction?.meterType}
                                        </td>
                                        <td>
                                            {transaction?.alias}
                                        </td>
                                        <td>
                                            <ElectricityBillerIcon name={name} />
                                        </td>
                                        <td>
                                        {<DropdownNew flipSwitch={true}>
                                                <></>
                                                <div>
                                                    <button type="button" onClick={() => toggleEditModal(transaction)} className="dropdown-item dropdown-item-icon text-left">
                                                    <EditIcon /> Edit
                                                    </button> 
                                                    <button type="button" onClick={() => toggleDeleteModal(transaction)} className="dropdown-item dropdown-item-icon text-ep-red-500 text-left">
                                                        <IconTrash /> Delete
                                                    </button>
                                                </div>
                                            </DropdownNew>}
                                        </td>
                                    </tr>
                                )}
                            )}
                        </Table.Body>
                    </Table>

                    <Maybe condition={loading === false && data?.data?.docs?.length > 0}>
                        <div className="mt-6">
                            <Pagination data={data?.data} />
                        </div>
                    </Maybe>

                </div>
            </div>
        </>
    )
}


const NewBeneficiaryButton = ({buttonText, toggleCreateBeneficiary}) => {
    return (
        <Menu as='div'>
            
            <Menu.Button className="">
                <div className="btn btn-ep-primary flex items-center justify-center">
                    <span>{buttonText}</span>
                    <FontAwesomeIcon icon="angle-down" fontSize={108} />
                </div>
            </Menu.Button>
            
            <Menu.Items as='div' className='dropdown'>
                <Menu.Item as='div' onClick={toggleCreateBeneficiary}>
                    <div className="dropdown-item flex items-center">
                        <IconUser />
                        <span className="ml-1">Add Single Beneficiary</span>
                    </div>
                </Menu.Item>
                
                {/* <Menu.Item>
                    <div className="dropdown-item flex items-center">
                        <IconUsers />
                        <span className="ml-1">Add Bulk Beneficiaries</span>
                    </div>
                </Menu.Item> */}
            </Menu.Items>
            
        </Menu>
    )
}


export default ElectricityBeneficiariesTable;